import React, { useRef, useState, useEffect } from "react"
import {
  InstantSearch,
  connectAutoComplete,
  connectHighlight,
} from "react-instantsearch-dom"
import tw from "twin.macro"

import { Menu, MenuItem, useLocation } from ".."
import { SearchBar as SB } from "./SearchBar"
import { Link, navigate } from "gatsby"
import { searchClient, urlToSearchState } from "../../helpers"

const SearchItem = connectHighlight(({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: "_highlightResult",
    attribute,
    hit,
  })

  return (
    <Link to={`/search/?query=${hit.title}`}>
      <MenuItem>
        {parsedHit.map((part, index) =>
          part.isHighlighted ? (
            <StyledSearchItem.Highlight key={index}>
              {part.value}
            </StyledSearchItem.Highlight>
          ) : (
            <span key={index}>{part.value}</span>
          )
        )}
      </MenuItem>
    </Link>
  )
})

const StyledSearchItem = {
  Highlight: tw.span`font-semibold`,
}

const SearchBar = connectAutoComplete(({ refine, currentRefinement, hits }) => {
  const inputRef = useRef(null)
  const [focus, setFocus] = useState(false)
  const location = useLocation()
  const { query } = urlToSearchState(location)

  useEffect(() => {
    if (location.pathname.search(/search/)) {
      refine(query as string)
    }
  }, [query])

  return (
    <StyledSearchBar.Wrapper>
      <SB
        ref={inputRef}
        value={currentRefinement}
        onChange={(event: any) => refine(event.currentTarget.value)}
        onFocus={() => setFocus(true)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            if (currentRefinement.length > 0) {
              navigate(`/search/?query=${currentRefinement}`)
            } else {
              navigate("/")
            }
          }
        }}
      />
      <StyledSearchBar.Menu
        open={currentRefinement.length > 0 && focus && !!hits.length}
        opener={inputRef}
        onClose={() => setFocus(false)}
      >
        {hits.map(
          (hit) =>
            currentRefinement.length > 0 && (
              <SearchItem
                key={(hit.fields as any).slug}
                hit={hit}
                attribute="title"
              />
            )
        )}
      </StyledSearchBar.Menu>
    </StyledSearchBar.Wrapper>
  )
})

const StyledSearchBar = {
  Wrapper: tw.div`relative`,
  Menu: tw(Menu)`absolute z-10 w-full mt-2`,
}

export const Search = () => {
  return (
    <InstantSearch
      indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
      searchClient={searchClient}
    >
      <SearchBar />
    </InstantSearch>
  )
}
